import { translate } from '@openclassrooms/translations';
import wysiwygFromDom from 'Modules/wysiwyg/services/wysiwygFromDom';

export default {
  create(element, editorOptions = {}) {
    if (!element) {
      throw new Error('Element Not Found');
    }

    if (
      element.classList.contains('js-wysiwyg-simple') ||
      element.classList.contains('js-prerequisites')
    ) {
      wysiwygFromDom(
        element,
        {
          plugins: 'autolink lists link',
          toolbar: 'bold italic | link | bullist numlist',
          block_formats: `${translate('course_editor.wysiwyg.word.title')} 1=Title1; ${translate(
            'course_editor.wysiwyg.word.title'
          )} 2=Title2; ${translate('course_editor.wysiwyg.word.paragraph')}=P`,
          min_height: 250,
        },
        editorOptions
      );
      return;
    }

    if (element.classList.contains('js-wysiwyg-admin-partner')) {
      wysiwygFromDom(element, {
        plugins: 'autoresize lists autolink link -claireImages -claireVideo',
        toolbar: 'blocks | bullist numlist | bold italic | link | claireImage claireVideo',
        formats: {
          Title1: { block: 'h2', classes: 'secondTitle' },
          Title2: { block: 'h3', attributes: { class: '' } },
          P: { block: 'p', attributes: { class: '' } },
        },
        block_formats: `${translate('course_editor.wysiwyg.word.title')} 1=Title1; ${translate(
          'course_editor.wysiwyg.word.title'
        )} 2=Title2; ${translate('course_editor.wysiwyg.word.paragraph')}=P`,
        min_height: 250,
      });
      return;
    }

    if (element.classList.contains('js-wysiwyg-path')) {
      wysiwygFromDom(element, {
        plugins:
          'autoresize lists autolink link code image -claireSanitize -claireImages -claireFormats -claireVideo',
        toolbar1:
          'blocks | aligncenter | bullist numlist | bold italic | claireImage claireVideo | blockquote | link | ',
        toolbar2: 'claireInfoBlock claireWarningBlock claireErrorBlock claireQuestionBlock',
        claireImage_use_figure: true,
        min_height: 500,
        formats: {
          Title1: { block: 'h2', classes: 'secondTitle' },
          Title2: { block: 'h3', attributes: { class: '' } },
          Title3: { block: 'h4', attributes: { class: '' } },
          P: { block: 'p', attributes: { class: '' } },
        },
        block_formats: `${translate('course_editor.wysiwyg.word.title')} 1=Title1; ${translate(
          'course_editor.wysiwyg.word.title'
        )} 2=Title2; ${translate('course_editor.wysiwyg.word.title')} 3=Title3;${translate(
          'course_editor.wysiwyg.word.paragraph'
        )}=P`,
      });
      return;
    }

    if (element.classList.contains('js-wysiwyg-mentor-feedback')) {
      wysiwygFromDom(element, {
        plugins: 'autoresize autolink lists link',
        toolbar: 'bold italic | link | bullist numlist',
        formats: {
          Title1: { block: 'h2', classes: 'secondTitle' },
          Title2: { block: 'h3', attributes: { class: '' } },
          P: { block: 'p', attributes: { class: '' } },
        },
        block_formats: `${translate('course_editor.wysiwyg.word.title')} 1=Title1; ${translate(
          'course_editor.wysiwyg.word.title'
        )} 2=Title2; ${translate('course_editor.wysiwyg.word.paragraph')}=P`,
        min_height: 250,
      });
      return;
    }

    throw new Error('Cant Find Editor Type For This Element');
  },
};
